'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _LazySizesJs = require('./LazySizes.js');

var _LazySizesJs2 = _interopRequireDefault(_LazySizesJs);

exports['default'] = _LazySizesJs2['default'];
module.exports = exports['default'];